import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WorkflowService } from './shared/services/workflow.service';
import { SharedModule } from './shared/shared.module';
import { ToastrModule } from 'ngx-toastr';
import { DataDialogComponent } from './main/questions/dialogs/data-dialog/data-dialog.component';
import { ConfirmDialogComponent } from './main/questions/dialogs/confirm-dialog/confirm-dialog.component';
import { AdditionalCostDialogComponent } from './main/questions/dialogs/additional-cost-dialog/additional-cost-dialog.component';
import { HttpErrorInterceptor } from './core/auth-interceptor.service';
import { ConfigurationService } from '@config/configuration.service';
import { QuestionDialogComponent } from './main/questions/dialogs/question-dialog/question-dialog.component';
import { LocationDialogComponent } from './main/questions/dialogs/location-dialog/location-dialog.component';
import { PromptComponent } from './main/layout/prompt/prompt.component';
import { PromptService } from './main/layout/prompt/prompt.service';
import { SplashScreenComponent } from './main/layout/splash-screen/splash-screen.component';
import { ImageService } from './shared/services/image.service';
import { CustomDialogComponent } from './main/questions/dialogs/custom-dialog/custom-dialog.component';
import { ExpandFailDialogComponent } from './main/questions/dialogs/expand-fail-dialog/expand-fail-dialog.component';
import { ListSelectionDialogComponent } from './main/questions/dialogs/list-selection-dialog/list-selection-dialog.component';
import { PhoneCallDialogComponent } from './main/questions/dialogs/phone-call-dialog/phone-call-dialog.component';

const initializer = (promptService: PromptService) => () => promptService.initPwaInstallPrompt();

@NgModule({
  declarations: [
    AppComponent,
    DataDialogComponent,
    ConfirmDialogComponent,
    CustomDialogComponent,
    QuestionDialogComponent,
    AdditionalCostDialogComponent,
    LocationDialogComponent,
    PromptComponent,
    SplashScreenComponent,
    ExpandFailDialogComponent,
    ListSelectionDialogComponent,
    PhoneCallDialogComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    CommonModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
  ],
  providers: [
    { 
      provide: APP_INITIALIZER, 
      useFactory: initializer, 
      deps: [PromptService], multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    ConfigurationService,
    WorkflowService,
    ImageService
  ],
  entryComponents: [
    DataDialogComponent,
    ConfirmDialogComponent,
    CustomDialogComponent,
    QuestionDialogComponent,
    AdditionalCostDialogComponent,
    LocationDialogComponent,
    PromptComponent,
    ExpandFailDialogComponent,
    ListSelectionDialogComponent,
    PhoneCallDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
